goog.provide("shadow.js.shim.module$react_autocomplete_input");
goog.provide("module$shadow_js_shim_module$react_autocomplete_input");
shadow.js.shim.module$react_autocomplete_input = shadow.js.nativeProvides["react-autocomplete-input"] = shadow$bridge("react-autocomplete-input");
module$shadow_js_shim_module$react_autocomplete_input.default = shadow.js.shim.module$react_autocomplete_input;
